<template>
  <div>
    <el-row>
      <el-col :span="24"
        ><div>
          <el-input
            class="search-el"
            size="mini"
            v-model="downloadOneOrder.order_id"
            placeholder="下载补录小鹅通订单"
          ></el-input>
          <el-button type="primary" size="mini" @click="downloadOneOrderExec()">
            下载补录小鹅通订单
          </el-button>
        </div></el-col
      >
    </el-row>
    <br />
    <el-row>
      <el-col :span="24"
        ><div>
          <el-date-picker
            v-model="downloadTimeZOrder.end_at"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            default-time="23:59:59"
            placeholder="选择结束时间"
            size="mini"
            >
        </el-date-picker>
          <el-button type="primary" size="mini" @click="downloadTimeZOrderExec()">
            下载补录某个时间点之前1小时内的小鹅通订单
          </el-button>
        </div></el-col
      >
    </el-row>
  </div>
</template>

<script>
import { downloadOneOrder, downloadTimeZOrder } from "@/api/order";

export default {
  data: function () {
    return {
      downloadOneOrder: {
        order_id: "",
      },
      downloadTimeZOrder: {
        end_at: "",
      },
    };
  },
  methods: {
    downloadOneOrderExec() {
      downloadOneOrder(this.downloadOneOrder).then((response) => {
        if (response.status == 2000) {
          this.$message({
            showClose: true,
            message: response.message,
            type: "success",
          });
        }
      });
    },
    downloadTimeZOrderExec() {
      downloadTimeZOrder(this.downloadTimeZOrder).then((response) => {
        if (response.status == 2000) {
          this.$message({
            showClose: true,
            message: response.message,
            type: "success",
          });
        }
      });
    },
  },
};
</script>

<style>
</style>